var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 20.1786H45.6V68.6071C44.7857 69.7001 44.3828 70.646 43.577 71.4448C42.7712 72.2435 41.817 72.6429 40.7143 72.6429V108.964C40.7143 110.057 40.3114 111.003 39.5056 111.802C38.6998 112.601 37.7455 113 36.6429 113H4.07143C2.96875 113 2.01451 112.601 1.20871 111.802C0.402902 111.003 0 110.057 0 108.964V76.6786L15.8404 21.6289C16.1373 20.662 16.7946 20.1786 17.8125 20.1786ZM48.8571 20.1786H65.1429V64.5714H48.8571V20.1786ZM98.1596 21.6289L114 76.6786V108.964C114 110.057 113.597 111.003 112.791 111.802C111.985 112.601 111.031 113 109.929 113H77.3571C76.2545 113 75.3002 112.601 74.4944 111.802C73.6886 111.003 73.2857 110.057 73.2857 108.964V72.6429C72.183 72.6429 71.2288 72.2435 70.423 71.4448C69.6172 70.646 69.2143 69.7001 68.4 68.6071V20.1786H96.1875C97.2054 20.1786 97.8627 20.662 98.1596 21.6289ZM46.2489 0.567522C46.6306 0.945871 46.8214 1.42932 46.8214 2.01786V16.1429H24.4286V2.01786C24.4286 1.42932 24.6194 0.945871 25.0011 0.567522C25.3828 0.189174 25.8705 0 26.4643 0H44.7857C45.3795 0 45.8672 0.189174 46.2489 0.567522ZM88.9989 0.567522C89.3806 0.945871 89.5714 1.42932 89.5714 2.01786V16.1429H67.1786V2.01786C67.1786 1.42932 67.3694 0.945871 67.7511 0.567522C68.1328 0.189174 68.6205 0 69.2143 0H87.5357C88.1295 0 88.6172 0.189174 88.9989 0.567522Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 113,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBino);
export default __webpack_public_path__ + "static/media/bino.5470a540637fa3004af8282d6bd2fc9d.svg";
export { ForwardRef as ReactComponent };